export default "__VITE_ASSET__eebbf2af__"